import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getFontFamilyMenuItems } from './lib'

/**
 * Settings subtitles font family menu
 */
export const SettingsSubtitlesFontFamilyMenu = createSubtitlesCustomMenu(
  'SettingsSubtitlesFontFamilyMenu',
  'font_family',
  getFontFamilyMenuItems
)
